export enum BookingMessageType {
  Citation = "citation",
  Warning = "warning",
  Info = "info",
}

export enum WaitingListModeType {
  CurrentEdition = "current-edition",
  FutureEdition = "future-edition",
  CurrentAndFutureEditions = "current-and-future-editions",
}
